import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'marina-file-upload',
  standalone: false,
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent {
  @Input() accept: string = '*/*';
  @Input() multiple: boolean = false;
  @Input() maxSize: number = 10485760; // 10MB default
  @Input() disabled: boolean = false;

  @Output() fileSelected = new EventEmitter<File[]>();
  @Output() fileError = new EventEmitter<string>();

  selectedFiles: File[] = [];
  dragOver: boolean = false;

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.handleFiles(Array.from(input.files));
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = false;

    if (event.dataTransfer?.files) {
      this.handleFiles(Array.from(event.dataTransfer.files));
    }
  }

  private handleFiles(files: File[]) {
    const validFiles: File[] = [];
    const errors: string[] = [];

    files.forEach(file => {
      if (file.size > this.maxSize) {
        errors.push(`${file.name} exceeds maximum size of ${this.maxSize / 1048576}MB`);
      } else {
        validFiles.push(file);
      }
    });

    if (errors.length > 0) {
      this.fileError.emit(errors.join(', '));
    }

    if (validFiles.length > 0) {
      this.selectedFiles = this.multiple ? [...this.selectedFiles, ...validFiles] : validFiles;
      this.fileSelected.emit(this.selectedFiles);
    }
  }

  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
    this.fileSelected.emit(this.selectedFiles);
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  }
}

